// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__yXhyH","text":"SelectPayment_text__P9b7O","title":"SelectPayment_title__3eAP1","btn":"SelectPayment_btn__342D1"};